import CaffeineCacheDocumentation from 'components/lookup-tables/caches/CaffeineCacheDocumentation';
import CaffeineCacheSummary from 'components/lookup-tables/caches/CaffeineCacheSummary';

import MongoDBDataAdapterFieldSet from './components/MongoDBDataAdapterFieldSet';
import MongoDBDataAdapterSummary from './components/MongoDBDataAdapterSummary';
import MongoDBDataAdapterDocumentation from './components/MongoDBDataAdapterDocumentation';
import IlluminateCSVFileAdapterFieldSet from './components/IlluminateCSVFileAdapterFieldSet';
import IlluminateCSVFileAdapterSummary from './components/IlluminateCSVFileAdapterSummary';
import IlluminateCSVFileAdapterDocumentation from './components/IlluminateCSVFileAdapterDocumentation';
import IlluminateCacheFieldSet from './components/IlluminateCacheFieldSet';

const lookupBindings = {
  lookupTableAdapters: [
    {
      type: 'mongodb',
      displayName: 'MongoDB',
      formComponent: MongoDBDataAdapterFieldSet,
      summaryComponent: MongoDBDataAdapterSummary,
      documentationComponent: MongoDBDataAdapterDocumentation,
    },
    {
      type: 'illuminate_csv',
      displayName: 'Illuminate Customizable',
      formComponent: IlluminateCSVFileAdapterFieldSet,
      summaryComponent: IlluminateCSVFileAdapterSummary,
      documentationComponent: IlluminateCSVFileAdapterDocumentation,
    },
  ],
  lookupTableCaches: [
    {
      type: 'illuminate_cache',
      displayName: 'Node-local, in-memory cache',
      formComponent: IlluminateCacheFieldSet,
      summaryComponent: CaffeineCacheSummary,
      documentationComponent: CaffeineCacheDocumentation,
    },
  ],
};

export default lookupBindings;
